import { useEffect } from "react";
import {
  IonItem,
  IonLabel,
  IonGrid,
} from "@ionic/react";
import "react-phone-number-input/style.css";
import React from "react";


interface IProps {
  isUpdate?: boolean;
  chat: any[];

}

const CreateTicket: React.FC<IProps> = (props) => {
  const { chat, isUpdate = false } = props;

  useEffect(() => {
    scrollToBottom();
  }, [chat]);

  const scrollToBottom = () => {
    const goToBottom = document.getElementById("go-to-bottom");
    if (goToBottom?.scrollIntoView)
      goToBottom.scrollIntoView({ behavior: "smooth" });
  };

  const isHTML = (str: any) => {
    const doc = new DOMParser().parseFromString(str, "text/html");
    return Array.from(doc.body.childNodes).some((node) => node.nodeType === 1);
  };


  return (
    <div>
      {!isUpdate && (
        <form>
          <IonGrid>
            {chat.map((element, index) => (
              <IonItem
                id={index === chat.length - 1 ? "go-to-bottom" : ""}
                lines="none"
                key={index}
                style={{
                  marginLeft: element.authorType === "agent" ? "8%" : "",
                  marginRight: element.authorType === "agent" ? "" : "8%",
                }}
              >
                <IonLabel
                  style={{
                    backgroundColor:
                      element.authorType === "agent" ? "#DCF8C6" : "#E5E5EA",
                    borderRadius: "10px",
                    padding: "10px",
                    alignSelf:
                      element.authorType === "agent" ? "flex-end" : "flex-start",
                    height: "auto",
                    display: "flex",
                    flexDirection: "column",
                    color: "#666",
                    whiteSpace: "pre-wrap",
                    overflow: "visible",
                  }}
                >
                  {element?.body}
                  {element?.attachments?.length > 0 && (
                    <div style={{ marginTop: '8px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                      {element.attachments.map((att: any, i: number) =>
                        att.mime?.startsWith('image/') ? (
                          <img
                            key={i}
                            src={att.url}
                            alt={att.name}
                            style={{ maxWidth: '200px', borderRadius: '8px', cursor: 'pointer' }}
                            onClick={() => window.open(att.url, '_blank')}
                          />
                        ) : (
                          <a key={i} href={att.url} target="_blank" rel="noreferrer" style={{ fontSize: '0.85em', color: '#3880ff' }}>
                            {att.name}
                          </a>
                        )
                      )}
                    </div>
                  )}
                  <div
                    style={{
                      fontSize: "0.8em",
                      color: "#666",
                      marginTop: "6px",
                      alignSelf:
                        element.authorType === "agent" ? "flex-end" : "flex-start",
                    }}
                  >
                    {element?.createdAt ? `${new Intl.DateTimeFormat("en-US", {
                      month: "short",
                      day: "2-digit",
                      year: "numeric",
                      hour: "numeric",
                      minute: "2-digit",
                      hour12: true,
                    }).format(new Date(element.createdAt))}` : ''}
                  </div>
                </IonLabel>
              </IonItem>
            ))}
          </IonGrid>
        </form>
      )}

    </div>
  );
};

export default CreateTicket;
